<template>
  <base-table
    title="Users"
    titleSingle="User"
    :headers="headers"
    :items="users"
    :valid="valid"
    :loading="loading"
    add
    @get-items="getUsers"
    @put-item="putUsers"
    @post-item="postUsers"
    @edit-item="editUsers"
    @delete-item="deleteUsers"
    @modal-open="getCompanies"
    @modal-close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model="user.firstname"
        :rules="[v => !!v || 'First name is required']"
        label="First Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="user.lastname"
        :rules="[v => !!v || 'Last name is required']"
        label="Last Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="user.emailAddress"
        :rules="[
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
        ]"
        type="email"
        label="Email Address"
        required
      ></v-text-field>
      <v-autocomplete
        v-model="user.role"
        :rules="[v => !!v || 'Role is required']"
        label="Role"
        :items="roles"
        item-text="name"
        item-value="value"
        required
      ></v-autocomplete>
      <v-autocomplete
        v-model="user.companyId"
        :rules="[v => !!v || 'Company is required']"
        label="Company"
        :items="companies"
        item-text="name"
        item-value="companyId"
        required
      ></v-autocomplete>
    </v-form>
  </base-table>
</template>

<script>
import UserService from "@/services/UserService.js";
import CompanyService from "@/services/CompanyService.js";
import BaseTable from "@/components/tables/BaseTable.vue";

export default {
  name: "UserTable",
  components: {
    BaseTable
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "emailAddress" },
        { text: "Company", value: "companyName" },
        { text: "Role", value: "roleDescription" },
        { text: "Actions", value: "action" }
      ],
      users: [],
      user: {
        userId: "",
        firstname: "",
        lastname: "",
        name: "",
        emailAddress: "",
        companyId: "",
        companyName: ""
      },
      valid: true,
      loading: true,
      roles: [
        { name: "Administrator", value: "ADM" },
        { name: "Security", value: "SEC" },
        { name: "Visitor", value: "VIS" },
        { name: "Contractor", value: "CON" },
        { name: "Employee", value: "EMP" }
      ],
      companies: []
    };
  },
  methods: {
    getUsers() {
      this.loading = true;
      UserService.getUsers()
        .then(response => {
          this.users = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getCompanies() {
      CompanyService.getCompanies().then(response => {
        this.companies = response;
      });
    },
    putUsers() {
      if (this.$refs.form.validate()) {
        UserService.putUser(this.user).then(() => {
          this.getUsers(), this.$snackbarSuccess("User Successfully Edited");
        });
      }
    },
    postUsers() {
      if (this.$refs.form.validate()) {
        UserService.postUser(this.user)
          .then(() => {
            this.getUsers(), this.$snackbarSuccess("User Successfully Added");
          })
          .catch(e => {
            alert(e.response.data);
          });
      }
    },
    editUsers(item) {
      this.user = Object.assign({}, item);
    },
    deleteUsers(item) {
      UserService.deleteUser(item.userId)
        .then(() => {
          this.getUsers(), this.$snackbarSuccess("User Deleted");
        })
        .catch(() => {
          this.$snackbarError("Internal Server Error");
        });
    },
    resetForm() {
      // Doesn't clear everything since an edit pulls in extra fields
      // Does that matter?
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
